export const gaConfig = {
  enabled: true,
  code: 'G-EQSX9FHRH3',
}
